{
  "INAPP-2055.spotlight.body": [
    {
      "type": 0,
      "value": "Draggable tags help you create well-defined alerts and manage them with ease. All you have to do is drag-and-drop the tags into any alert property field as needed"
    }
  ],
  "INAPP-2055.spotlight.primary": [
    {
      "type": 0,
      "value": "Learn more"
    }
  ],
  "INAPP-2055.spotlight.secondary": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "INAPP-2055.spotlight.title": [
    {
      "type": 0,
      "value": "Create rich and informative alerts"
    }
  ],
  "INAPP-3273.spotlight.body": [
    {
      "type": 0,
      "value": "Triage and resolve alerts faster by using Atlassian Intelligence to access similar alerts."
    }
  ],
  "INAPP-3273.spotlight.primary": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "INAPP-3273.spotlight.title": [
    {
      "type": 0,
      "value": "Drive faster alert resolution with Atlassian Intelligence"
    }
  ],
  "aiops-grogu.rovo-ops-cta-spotlight.body": [
    {
      "type": 0,
      "value": "Investigate and compare alerts, and find related resources to resolve faster."
    }
  ],
  "aiops-grogu.rovo-ops-cta-spotlight.done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "aiops-grogu.rovo-ops-cta-spotlight.heading": [
    {
      "type": 0,
      "value": "Triage alerts with Rovo Ops"
    }
  ],
  "jira-ops-group-customisation.spotlight.body": [
    {
      "type": 0,
      "value": "Your team's alerts are grouped based on the similarity of alert titles, descriptions, tags and so on within a specific time window. If you want more control, you can fine-tune how alerts are grouped. Only team admins, Ops admins, or Jira admins can change these settings."
    }
  ],
  "jira-ops-group-customisation.spotlight.primary": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "jira-ops-group-customisation.spotlight.title": [
    {
      "type": 0,
      "value": "Configure alert groups"
    }
  ],
  "jira-ops-unified-view-revamp.grouped-alerts.spotlight.body": [
    {
      "type": 0,
      "value": "Expand to quickly view all alerts in the group."
    }
  ],
  "jira-ops-unified-view-revamp.grouped-alerts.spotlight.title": [
    {
      "type": 0,
      "value": "View grouped alerts"
    }
  ],
  "jira-ops-unified-view-revamp.snr-header.spotlight.body": [
    {
      "type": 0,
      "value": "Rovo helps you classify your alerts as signal or noise so you can focus on what matters most."
    }
  ],
  "jira-ops-unified-view-revamp.snr-header.spotlight.title": [
    {
      "type": 0,
      "value": "Triage alerts faster"
    }
  ],
  "jira-ops-unified-view-revamp.spotlight.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "jira-ops-unified-view-revamp.spotlight.go-back": [
    {
      "type": 0,
      "value": "Go back"
    }
  ],
  "jira-ops-unified-view-revamp.spotlight.next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "jira-ops-unified-view-revamp.spotlight.ok": [
    {
      "type": 0,
      "value": "OK"
    }
  ]
}